import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { SITE_URL } from "@/constants/siteUrl";
import { cn } from "@/lib/utils";

interface Props {
  content: Parameters<typeof documentToReactComponents>[0];
  className?: string;
}

const isExternal = (url: string) => {
  try {
    return new URL(url).origin !== new URL(SITE_URL).origin;
  } catch {
    return false;
  }
};

export const Prose = ({ content, className }: Props) => {
  return (
    <div
      className={cn("prose text-base font-normal leading-normal [&_li>p]:my-0", className)}
      style={
        {
          "--tw-prose-body": "var(--foreground)",
          "--tw-prose-headings": "var(--foreground)",
        } as React.CSSProperties
      }
    >
      {documentToReactComponents(content, {
        renderNode: {
          hyperlink: (node, children) => {
            const uri = node.data.uri as string;
            const external = isExternal(uri);
            return (
              <a href={uri} {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}>
                {children}
              </a>
            );
          },
        },
      })}
    </div>
  );
};
